import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function ShareBoldIcon(props: Props) {
  const { t } = useLingui()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <title>{t`Share icon`}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.53338 5.19699C6.24048 5.48987 5.7656 5.48986 5.47272 5.19695C5.17984 4.90405 5.17985 4.42918 5.47276 4.13629L7.4729 2.13629L8.00321 1.60602L8.53352 2.13629L10.5337 4.13629C10.8266 4.42918 10.8266 4.90405 10.5337 5.19695C10.2408 5.48986 9.76594 5.48987 9.47303 5.19699L8.75321 4.47721V9.99997C8.75321 10.4142 8.41742 10.75 8.00321 10.75C7.58899 10.75 7.25321 10.4142 7.25321 9.99997V4.47721L6.53338 5.19699ZM5.75305 8.08331C5.2007 8.08331 4.75293 8.53108 4.75293 9.08344V9.99998C4.75293 11.0585 5.61105 11.9166 6.6696 11.9166H9.33682C10.3954 11.9166 11.2535 11.0585 11.2535 9.99998V9.08344C11.2535 8.53108 10.8057 8.08331 10.2534 8.08331C9.83915 8.08331 9.50336 7.74753 9.50336 7.33331C9.50336 6.9191 9.83915 6.58331 10.2534 6.58331C11.6341 6.58331 12.7535 7.70266 12.7535 9.08344V9.99998C12.7535 11.887 11.2238 13.4166 9.33682 13.4166H6.6696C4.78262 13.4166 3.25293 11.887 3.25293 9.99998V9.08344C3.25293 7.70266 4.37227 6.58331 5.75305 6.58331C6.16726 6.58331 6.50305 6.9191 6.50305 7.33331C6.50305 7.74753 6.16726 8.08331 5.75305 8.08331Z"
        fill="currentColor"
      />
    </svg>
  )
}
